module.exports = __webpack_public_path__ + "static/media/apns.92c0b4e9.jpg";